import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  PLATFORM_INTEGRATIONS_NAMESPACE_INJECTION_TOKEN$,
  PlatformIntegrationsI18nModule,
} from '@galaxy/platform-integrations/shared';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatAnchor } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'platform-integration-not-found',
  imports: [
    CommonModule,
    PlatformIntegrationsI18nModule,
    TranslateModule,
    GalaxyEmptyStateModule,
    MatAnchor,
    RouterLink,
  ],
  templateUrl: './not-found.html',
  styleUrl: './not-found.scss',
})
export class NotFoundComponent {
  protected routeLink$ = this.namespace$.pipe(
    map((namespace) => {
      return `/account/location/${namespace}/administration/integrations`;
    }),
  );

  constructor(
    @Inject(PLATFORM_INTEGRATIONS_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>,
  ) {}
}
